module.exports = __webpack_public_path__ + "static/media/contactPhoneLogo.99d95845.svg";